import { matchPath } from "react-router-dom";

const normalizePathname = (pathname = "/") => {
  const withLeadingSlash = pathname.startsWith("/") ? pathname : `/${pathname}`;
  const withoutTrailingSlashes = withLeadingSlash.replace(/\/+$/, "");

  return withoutTrailingSlashes || "/";
};

const flattenPages = (pages = []) =>
  pages.flatMap((page) => [page, ...flattenPages(page.subMenus || [])]);

const isPathWithin = (pathname, basePath) =>
  basePath !== "/" &&
  (pathname === basePath || pathname.startsWith(`${basePath}/`));

/**
 * Resolves the sidebar item from the URL, including detail/edit routes that
 * should keep their nearest visible parent selected.
 */
export const getActiveMenuKeyByPath = (pathname, pages = []) => {
  const normalizedPath = normalizePathname(pathname);
  const currentPath = normalizedPath === "/home" ? "/" : normalizedPath;
  const allPages = flattenPages(pages);
  const exactRoute = allPages.find(
    (page) =>
      page.path &&
      matchPath({ path: page.path, end: true }, currentPath) !== null,
  );

  if (exactRoute?.activeMenuKey) return exactRoute.activeMenuKey;
  if (exactRoute?.showInSider) return exactRoute.name;

  const closestVisibleParent = allPages
    .filter((page) => page.showInSider && page.path)
    .map((page) => ({
      ...page,
      normalizedPath: normalizePathname(page.path),
    }))
    .filter((page) => isPathWithin(currentPath, page.normalizedPath))
    .sort((first, second) => second.normalizedPath.length - first.normalizedPath.length)[0];

  if (closestVisibleParent) return closestVisibleParent.name;

  if (currentPath === "/") {
    return allPages.find(
      (page) => page.showInSider && normalizePathname(page.path) === "/",
    )?.name;
  }

  return null;
};

